import { createClient } from "@supabase/supabase-js";

// Read environment variables
const SUPABASE_URL = process.env.VUE_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.VUE_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Supabase URL or ANON KEY not found in environment variables");
}

// API calls must never be served from the browser's HTTP cache. PostgREST
// answers some errors with HTTP 300 (e.g. an ambiguous embed), which browsers
// cache by default — so a transient server-side problem kept being replayed
// for that URL long after it was fixed (Oct 2026, campaign page). `no-store`
// on every request makes the client always ask the server.
const noStoreFetch = (input, init = {}) => fetch(input, { ...init, cache: "no-store" });

// Initialize Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: { fetch: noStoreFetch },
});
